export const URL = "https://scopey.software";
//export const URL = "https://scopey-test.web.app";
//export const URL = "https://scopey-dev.web.app";
//export const URL= "http://localhost:3000";
